export const getTaxRate = (province) => {
	province = province ? province.toLowerCase() : "ontario";
	switch (province) {
		case "ontario":
		case "on":
			return 0.13;
		case "alberta":
		case "ab":
			return 0.05;
		case "british colombia":
		case "bc":
			return 0.12;
		case "manitoba":
		case "mb":
			return 0.12;
		case "quebec":
		case "qc":
			return 0.14975;
		case "al":
			return 0.04;
		case "ak":
			return 0;
		case "az":
			return 0.056;
		case "ar":
			return 0.065;
		case "ca":
			return 0.0725;
		case "co":
			return 0.029;
		case "ct":
			return 0.0635;
		case "de":
			return 0;
		case "dc":
			return 0.06;
		case "fl":
			return 0.06;
		case "ga":
			return 0.04;
		case "hi":
			return 0.04;
		case "id":
			return 0.06;
		case "il":
			return 0.0625;
		case "in":
			return 0.07;
		case "ia":
			return 0.06;
		case "ks":
			return 0.065;
		case "ky":
			return 0.06;
		case "la":
			return 0.0445;
		case "me":
			return 0.055;
		case "md":
			return 0.06;
		case "ma":
			return 0.0625;
		case "mi":
			return 0.06;
		case "mn":
			return 0.06875;
		case "ms":
			return 0.07;
		case "mo":
			return 0.04225;
		case "mt":
			return 0;
		case "ne":
			return 0.055;
		case "nv":
			return 0.0685;
		case "nh":
			return 0;
		case "nj":
			return 0.06625;
		case "nm":
			return 0.05125;
		case "ny":
			return 0.04;
		case "nc":
			return 0.0475;
		case "nd":
			return 0.05;
		case "oh":
			return 0.0575;
		case "ok":
			return 0.045;
		case "or":
			return 0;
		case "pa":
			return 0.06;
		case "ri":
			return 0.07;
		case "sc":
			return 0.06;
		case "sd":
			return 0.045;
		case "tn":
			return 0.07;
		case "tx":
			return 0.0625;
		case "ut":
			return 0.047;
		case "vt":
			return 0.06;
		case "va":
			return 0.043;
		case "wa":
			return 0.065;
		case "wv":
			return 0.06;
		case "wi":
			return 0.05;
		case "wy":
			return 0.04;
		case "sk":
			return 0.11;
		case "ns":
			return 0.14;
		default:
			return 0.15;
	}
};
